import { useEffect, useState, ComponentType } from "react";
import { ModalProps } from "./index";

/*
 This recommended pattern of allowing extra unspecified properties does not work at all.
 Leaving it here in comments as documentation and a reminder to not waste any more time with this crap.

interface CloseAfterExitedProps extends Pick<ModalProps, "onClose"|"show"> {
  [key:string]: any;
}
*/

export interface CloseAfterExitedProps
  extends Pick<ModalProps, "onClose" | "show"> {}

export default function withCloseAfterExited<C extends CloseAfterExitedProps>(
  Component: ComponentType<C>
) {
  // Try to create a nice displayName for React Dev Tools.
  const displayName = Component.displayName || Component.name || "Component";
  const ComponentWithCloseAfterExited = (props: C) => {
    const { show, onClose, ...other } = props as any;
    const [myShow, setMyShow] = useState<boolean | undefined>(show);
    const [callbackAfterExited, setCallbackAfterExited] =
      useState<() => void | undefined>();
    useEffect(() => {
      setMyShow(show);
    }, [show]);
    const myHide = (callback?: () => void) => {
      setMyShow(false);
      setCallbackAfterExited(() =>
        callback && typeof callback === "function" ? callback : undefined
      );
    };
    const onExited = () => {
      if (onClose) {
        onClose(callbackAfterExited);
      } else if (callbackAfterExited) {
        callbackAfterExited();
      }
    };
    return (
      <Component
        {...other}
        show={myShow}
        onClose={myHide}
        onExited={onExited}
      />
    );
  };
  ComponentWithCloseAfterExited.displayName = `withCloseAfterExited(${displayName})`;
  return ComponentWithCloseAfterExited;
}
